import { writable } from 'svelte/store'
import ApiService from '../api-service/api'

export const users = writable([])

export const fetch = async () => {
  users.set((await ApiService.get('users')).data)
}
